import { render } from "./mongo-cache-collection.vue?vue&type=template&id=1af90e58&scoped=true"
import script from "./mongo-cache-collection.vue?vue&type=script&lang=js"
export * from "./mongo-cache-collection.vue?vue&type=script&lang=js"

import "./mongo-cache-collection.vue?vue&type=style&index=0&id=1af90e58&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af90e58"]])

export default __exports__